import CryptoJS from "crypto-js";
import * as AuthenticationUtils from "../Utils/AuthenticationUtils";
import * as PathUtils from "../../components/Utils/PathUtils";
import * as ErrorUtils from "../Utils/ErrorUtils";

import LogService from "../CommonSdk/LogService";

const LOG_TAG = "SERVICE:AUTHENTICATION";
const appId = "bb647d70011b11e8bbbf4dc516c3061b";
const RainbowAppAuthHeaderKey = "x-rainbow-app-auth";
const RainbowClientVersionHeaderKey = "x-rainbow-client-version";

export const login = (loginUrl, email, password) => {
    LogService.trace(LOG_TAG, "login", "enter");

    let wrapped = AuthenticationUtils.getWrapper(loginUrl);

    let request = new Request(
        loginUrl,
        {
            headers: new Headers({
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Basic " + window.btoa(email + ":" + password),
                "x-rainbow-client": "rainbowhub",
                "x-rainbow-client-version": window.version,
                "x-rainbow-app-auth": "Basic " + window.btoa(appId + ":" + CryptoJS.SHA256(wrapped + password))
            }),
            method: "GET"
        }
    );

    return fetch(request)
        .then(response => response.ok ? response.json() : response.json().then((error) => Promise.reject(error)))
        .then(json => {
            LogService.info(LOG_TAG, "login", "success");
            return Promise.resolve(json);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "login", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const logout = (logoutUrl, token) => {
    LogService.trace(LOG_TAG, "logout", "enter");

    let request = new Request(
        logoutUrl,
        {
            headers: new Headers({
                accept: "application/json",
                authorization: "Bearer " + token
            }),
            method: "GET"
        }
    );

    return fetch(request)
        .then(response => response.ok ? response.json() : response.json().then((error) => Promise.reject(error)))
        .then(json => {
            LogService.info(LOG_TAG, "logout", "success");
            return Promise.resolve(json);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "logout", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const getUserEnvironment = (serverUrl, email) => {
    LogService.trace(LOG_TAG, "getUserEnvironment", "enter");
    let request = new Request(
        serverUrl + "/api/rainbow/multienvironments/v1.0/environments?loginEmail=" + email,
        {
            method: "GET"
        }
    );

    return fetch(request)
        .then(response => response.ok ? response.json() : response.json().then((error) => Promise.reject(error)))
        .then(json => {
            LogService.info(LOG_TAG, "getUserEnvironment", "success");
            return Promise.resolve(json);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getUserEnvironment", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const getUserAuthentication = (serverUrl, email) => {
    LogService.trace(LOG_TAG, "getUserAuthentication", "enter");
    let request = new Request(
        serverUrl + "/api/rainbow/authentication/v1.0/urls?uid=" + email,
        {
            method: "GET"
        }
    );

    return fetch(request)
        .then(response => response.ok ? response.json() : response.json().then((error) => Promise.reject(error)))
        .then(json => {
            LogService.info(LOG_TAG, "getUserAuthentication", "success");
            return Promise.resolve(json);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getUserAuthentication", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const getSsoLoginUrl = (loginUrl, challenge, version = 0) => {
    LogService.trace(LOG_TAG, "getSsoLoginUrl", "enter");

    let wrapped = AuthenticationUtils.getWrapper(loginUrl);

    let loginPathName = PathUtils.addOrUpdateQueryParameterToPathString(loginUrl, RainbowAppAuthHeaderKey, window.btoa(appId + ":" + CryptoJS.SHA256(wrapped + challenge)));
    loginPathName = PathUtils.addOrUpdateQueryParameterToPathString(loginPathName, RainbowClientVersionHeaderKey, version);

    const url = new URL(loginPathName, loginUrl);
    return Promise.resolve(url.toString());
}